import { Component, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@env/environment';
import { LoginComponent } from '@app/auth/login/login.component';
import { MatDialog } from '@angular/material/dialog';
import { PopupService } from '@app/shared/services/popup/popup.service';
import { SignupComponent } from '@app/auth/signup/signup.component';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'StoreBuilderApp';

  constructor(private router: Router,
    private dialog: MatDialog,
    private popupService: PopupService) {
    function getCookie(name: any) {
      const value = '; ' + document.cookie;
      const parts = value.split('; ' + name + '=');
      if (parts.length === 2) {
        return parts.pop()?.split(';').shift() ?? null;
      }
      return null;
    }

    function setCookie(name: string, value: string, days: number) {
      let expires = '';
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toUTCString();
      }
      document.cookie = name + '=' + (value || '') + expires + '; path=/';
    }

    if (getCookie('installKey')) {
      setCookie('installKey', '', 0);
      document.location.href = '/store/list?apikey=' + getCookie('shopKey');
    }
    this.forceHttps();
    this.popupService.openLoginSub().subscribe(value => value.open ? this.openLogin(value.data.endUser) : '');
    this.popupService.openSignUpSub().subscribe(value => value.open ? this.openSignUp(value.data.endUser) : '');
  }
  ngOnInit() {
  }


  forceHttps() {
    if (environment.production && location.protocol !== 'https:') {
      location.replace(`https:${location.href.substring(location.protocol.length)}`);
    }
  }

  openLogin(endUser = false) {
    
    this.dialog.open(LoginComponent, {
      disableClose: false,
      width: window.innerWidth >= 767 ? '50%' : '80%',
      data: { endUser: endUser }
    });
  }

  openSignUp(endUser = false) {
    this.dialog.open(SignupComponent, {
      disableClose: true,
      width: window.innerWidth >= 767 ? '50%' : '80%',
      data: { endUser: endUser }
    });
  }

}
